import { render, staticRenderFns } from "./BanPolicies.vue?vue&type=template&id=2bba25f6&"
import script from "./BanPolicies.vue?vue&type=script&lang=ts&"
export * from "./BanPolicies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports